export const BUBBLE_THEMES = {
  default: {
    light: {
      userBg: '#dcf8c6',
      userText: '#000000',
      aiBg: '#e9e9e9',
      aiText: '#000000',
    },
    dark: {
      userBg: '#2a3a2a',
      userText: '#e0e0e0',
      aiBg: '#2a2a2e',
      aiText: '#e0e0e0',
    },
  },
}

export const BUBBLE_CSS_PRESETS: Record<string, string> = {
  'latte': `.chat-bubble-user {
  background: rgba(255, 255, 255, 0.75) !important;
  backdrop-filter: blur(40px) !important;
  -webkit-backdrop-filter: blur(40px) !important;
  border: 2px solid #A1887F !important;
  border-radius: 14px !important;
  color: #333 !important;
  padding: 8px 18px !important;
}
.chat-bubble-ai {
  background: rgba(255, 255, 255, 0.75) !important;
  backdrop-filter: blur(40px) !important;
  -webkit-backdrop-filter: blur(40px) !important;
  border: 2px solid #A1887F !important;
  border-radius: 14px !important;
  color: #333 !important;
  padding: 8px 18px !important;
}`,

  'qq': `.chat-bubble-user {
  background-color: #3A80E6 !important;
  color: #ffffff !important;
  border-radius: 20px !important;
  padding: 8px 16px !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1) !important;
  position: relative !important;
}
.chat-bubble-ai {
  background-color: #ffffff !important;
  color: #333333 !important;
  border-radius: 20px !important;
  padding: 8px 16px !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1) !important;
  position: relative !important;
}`,

  'wechat': `.chat-bubble-user {
  background-color: #95EC69 !important;
  color: #000 !important;
  border-radius: 6px !important;
  padding: 8px 16px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
  position: relative !important;
}
.chat-bubble-user::after {
  content: '' !important;
  position: absolute !important;
  right: -6px !important;
  bottom: 50% !important;
  transform: translateY(50%) !important;
  width: 0 !important;
  height: 0 !important;
  border-style: solid !important;
  border-width: 4px 0 4px 6px !important;
  border-color: transparent transparent transparent #95EC69 !important;
}
.chat-bubble-ai {
  background-color: #fff !important;
  color: #000 !important;
  border-radius: 6px !important;
  padding: 8px 16px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
  position: relative !important;
}
.chat-bubble-ai::after {
  content: '' !important;
  position: absolute !important;
  left: -6px !important;
  bottom: 50% !important;
  transform: translateY(50%) !important;
  width: 0 !important;
  height: 0 !important;
  border-style: solid !important;
  border-width: 4px 6px 4px 0 !important;
  border-color: transparent #fff transparent transparent !important;
}`,

  'piggy': `.chat-bubble-user {
  background: rgba(255,230,240,0.4) !important;
  background-image: url("https://img.heliar.top/file/1775647619154_retouch_2026040819085493.png") !important;
  background-repeat: no-repeat !important;
  background-position: left 8px center !important;
  background-size: 18px !important;
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  color: #800036 !important;
  border: 1px solid rgba(255,210,230,0.5) !important;
  border-radius: 12px !important;
  padding: 8px 12px 8px 32px !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05) !important;
  line-height: 1.4 !important;
}
.chat-bubble-ai {
  background: rgba(255,230,240,0.4) !important;
  background-image: url("https://img.heliar.top/file/1775646613625_retouch_2026040819082528.png") !important;
  background-repeat: no-repeat !important;
  background-position: right 8px center !important;
  background-size: 24px !important;
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  color: #800036 !important;
  border: 1px solid rgba(255,210,230,0.5) !important;
  border-radius: 12px !important;
  padding: 8px 32px 8px 12px !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05) !important;
  line-height: 1.4 !important;
}`,

  'glass': `.chat-bubble-user {
  background: transparent !important;
  color: #333 !important;
  border: 1px solid rgba(255,255,255,0.4) !important;
  border-radius: 8px !important;
  box-shadow: inset 0 0 6px rgba(255,255,255,0.5) !important;
  padding: 4px 10px !important;
  line-height: 1.4 !important;
  position: relative !important;
}
.chat-bubble-ai {
  background: transparent !important;
  color: #333 !important;
  border: 1px solid rgba(255,255,255,0.4) !important;
  border-radius: 8px !important;
  box-shadow: inset 0 0 6px rgba(255,255,255,0.5) !important;
  padding: 4px 10px !important;
  line-height: 1.4 !important;
  position: relative !important;
}`,

  'blue-pink': `.chat-bubble-user {
  background: rgba(255,230,240,0.4) !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  color: #4a3a42 !important;
  border: 1px solid rgba(255,210,230,0.5) !important;
  border-radius: 12px !important;
  padding: 8px 12px 8px 32px !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05) !important;
  line-height: 1.4 !important;
}
.chat-bubble-ai {
  background: rgba(230,242,255,0.4) !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  color: #3a4a5c !important;
  border: 1px solid rgba(200,225,250,0.5) !important;
  border-radius: 12px !important;
  padding: 8px 32px 8px 12px !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05) !important;
  line-height: 1.4 !important;
}`,
}
